import React from 'react';
import Header from '@/features/facility/welcome/components/Header';
import Footer from '@/features/facility/welcome/components/Footer';
import ContactMailMain from '../components/ContactMailMain';

const ContactMail = () => {
  return (
    <React.Fragment>
      <Header />
      <ContactMailMain />
      <Footer />
    </React.Fragment>
  );
};

export default ContactMail;